// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__33tTX","buttons":"SendReceipts_buttons__2FoYY","email":"SendReceipts_email__37sDE","bookApptTitle":"SendReceipts_bookApptTitle__6TS7_"};